import { useAuth0 } from '@auth0/auth0-react';
import { useBackoffice } from '../../backoffice/useBackoffice';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import axios from 'axios';

export type FuseOnbaordingStatusDetails = {
  entities: {
    entity:
      | 'customer.individual'
      | 'customer.business'
      | 'customer.business.document.poa'
      | 'customer.business.ubo'
      | 'customer.business.ubo.document.poa';
    status: 'success' | 'awaiting_manual_onboarding' | 'error';
    details?: Record<string, any>;
  }[];
};

export const useFuseDetails = (customerId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const { developerId, isBackofficeOn } = useBackoffice();
  const query = useQuery({
    queryKey: ['fuse-details', developerId, customerId],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/customers/${customerId}/fuse`, {
        params: {
          consumerId: developerId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.data?.data;
    },
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
    enabled: isBackofficeOn && !!customerId,
  });

  return query;
};
